import { AddInsuranceButtonField } from './addInsuranceButtonField';
import { InsuranceEntryField } from './insuranceEntryField';
import './insuranceEntryStyle.css';
import { InsuranceEntryItemType } from '@/types/bodyAndPaint';

interface AddInsuranceInfoFieldProps {
  state: InsuranceEntryItemType;
  setState: {
    insuranceSelect: (select: number) => void;
    companyPick: (pick: string) => void;
    certificateText: (text: string) => void;
    receiptNumberText: (text: string) => void;
    deductibleSelect: (select: number) => void;
    deductibleText: (text: string) => void;
    repairPlanSelect: (select: number) => void;
  };
  selectList: {
    insuranceSelect: string[];
    deductibleSelect: string[];
    repairPlanSelect: string[];
  };
  error: {
    certificateText: string;
    receiptNumberText: string;
    deductibleText: string;
  };
  pickerInfo: {
    inputID: string;
    containerID: string;
    select: string;
  };
  hasDeductible: boolean;
  addInsurance?: boolean;
  isInsurance: boolean;
  disabled: boolean;
  onRegisterInsurance: () => void;
  cancelEntry: () => void;
}
export const AddInsuranceInfoField = ({
  state,
  setState,
  selectList,
  error,
  pickerInfo,
  hasDeductible,
  addInsurance,
  isInsurance,
  disabled,
  onRegisterInsurance,
  cancelEntry,
}: AddInsuranceInfoFieldProps) => {
  return (
    <div className={'add-insurance-info-field'}>
      <InsuranceEntryField
        addInsurance={addInsurance}
        isInsurance={isInsurance}
        hasDeductible={hasDeductible}
        state={state}
        setState={setState}
        selectList={selectList}
        error={error}
        picker={pickerInfo}
      />
      <AddInsuranceButtonField
        disabled={disabled}
        addInsurance={onRegisterInsurance}
        cancelEntry={cancelEntry}
      />
    </div>
  );
};
